import intlMessageEN from '../../components/ il8n/locales/en.json';

export function getLocale() {
    const locale = navigator.language;
    switch (locale) {
        default:
            return "en"
    }
}

export function getMessages() {
    const locale = getLocale()
    switch (locale) {
        default:
            return intlMessageEN
    }
}


// WEBPACK FOOTER //
// ./src/components/handler/LocaleHandler.js